import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { DecimalPipe } from "@angular/common";

interface SymbolRendererParams extends ICellRendererParams {
  type: string;
}

@Component({
  selector: "app-symbol-amount-renderer",
  templateUrl: "./symbol-amount-renderer.component.html",
  providers: [DecimalPipe],
})
export class SymbolAmountRendererComponent implements ICellRendererAngularComp {
  amount!: string;
  type!: string;

  constructor(private decimalPipe: DecimalPipe) {}

  agInit(params: SymbolRendererParams): void {
    this.type = params.type;
    this.setData(params);
  }

  setData(params: SymbolRendererParams) {
    const field = this.type === "amount" ? "amount" : "convertedAmount";
    const initialAmount = params.data[field] || 0;

    this.amount = this.decimalPipe.transform(initialAmount, "1.2-2") || `Unavailable ${field}`;
  }

  refresh(params: SymbolRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
